export default "__VITE_ASSET__DGWAxFh3__"